/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIRoleRequest
 */
export interface APIRoleRequest {
    /**
     * Guest user roles are roles that are reserved for the guest user type. They work like a normal organization user role, but won't be listed by the RoleViewSet.
     * @type {boolean}
     * @memberof APIRoleRequest
     */
    isGuestUserRole?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIRoleRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIRoleRequest
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIRoleRequest
     */
    permissions?: { [key: string]: any; };
}

/**
 * Check if a given object implements the APIRoleRequest interface.
 */
export function instanceOfAPIRoleRequest(value: object): value is APIRoleRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIRoleRequestFromJSON(json: any): APIRoleRequest {
    return APIRoleRequestFromJSONTyped(json, false);
}

export function APIRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isGuestUserRole': json['is_guest_user_role'] == null ? undefined : json['is_guest_user_role'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
    };
}

export function APIRoleRequestToJSON(value?: APIRoleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'is_guest_user_role': value['isGuestUserRole'],
        'name': value['name'],
        'description': value['description'],
        'permissions': value['permissions'],
    };
}

